export const searchSettings = {
  limit: 20,
  offset: 20,
};

export const searchSettingsForAllData = {
  limit: 2000,
  offset: 0,
};
